import { baseUrl } from './general-api';

export interface ContactImage {
  renditions: {
    small: {
      link: string;
    };
    large: {
      link: string;
    };
  };
}

export interface ContactsResponse {
  companyName: string;
  address: string;
  postalCode: string;
  city: string;
  region: string;
  country: string;
  accountManager: string;
  phone: string;
  image: ContactImage;
  website: string;
  guid: string;
}

/**
 * Base URL for the Contacts API.
 */
export const contactsEndpoint = baseUrl + '/.rest/delivery/v1/contacts';

export const getContactsForCountry = (country: string): Promise<ContactsResponse[]> => {
  const params: Record<string, string> = {};

  params.country = country;
  const parameterString = new URLSearchParams(params).toString();
  const url = `${contactsEndpoint}?${parameterString}`;

  return fetch(url)
    .then((response) => response.json())
    .then((data) => {
      return data.results;
    })
    .catch(() => {
      return [];
    });
};
